var opts = {
    definitions: {
      '#': {
        validator: '[0-9]',
        cardinality: 1,
      },
      '@': {
        validator: '[0-9./]',
        cardinality: 1,
      },
      '>': {
        validator: '[0-9a-zA-Z./\\-]',
        cardinality: 1,
      },
    },
    showMaskOnHover: false,
    autoUnmask: false,
  },
  masks = {
    ip: {
      mask: '(aaaa)|(@{10,18})',
      placeholder: '',
    },
    mac: {
      mask: '**(:**){5}',
      placeholder: '00:00:00:00:00:00',
    },
    number: {
      mask: '#{*}',
    },
    range: {
      mask: '#{*}[:]{1}#{*}',
    },
    date: {
      mask: '##/##/####',
      placeholder: 'MM/DD/YYYY',
    },
    url: Inputmask.prototype.aliases.url,
  },
  get = function (propertyType) {
    return masks[propertyType] || '';
  },
  applyMasks = function () {
    var inputMasks, i, mask;

    if (navigator.userAgent.indexOf('capybara') > 0) {
      return;
    }

    if (this.$ === undefined) {
      inputMasks = this.find('[mask], [data-inputmask-alias]');
    } else {
      inputMasks = this.$('[mask], [data-inputmask-alias]');
    }

    i = inputMasks.length - 1;

    for (i; i >= 0; i--) {
      mask = inputMasks[i].getAttribute('mask');

      if (mask !== null && get(mask) !== '') {
        $(inputMasks[i]).inputmask($.extend({}, opts, get(mask)));
      } else {
        $(inputMasks[i]).inputmask();
      }
    }
  };

module.exports = {
  get: get,
  opts: opts,
  applyMasks: applyMasks,
};
